import {
  SHOW_INSTAGRAM_AS_PUBLISH_TARGET,
} from '../../config/featureFlags';

/** Drop Instagram from publish/schedule platform pickers when dual-publish-only. */
export function excludeInstagramFromOptions(items) {
  if (SHOW_INSTAGRAM_AS_PUBLISH_TARGET) return items;
  return items.filter((o) => {
    const v = String(o.value || o.label || '').toLowerCase();
    return v !== 'instagram';
  });
}

export const contentTypes = ['text', 'image', 'video', 'story', 'reel', 'article'];

export const PLATFORM_OPTIONS = excludeInstagramFromOptions([
  { value: 'facebook', label: 'Facebook' },
  { value: 'youtube', label: 'YouTube' },
  { value: 'x', label: 'X (Twitter)' },
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'instagram', label: 'Instagram' },
  { value: 'tumblr', label: 'Tumblr' },
  { value: 'pinterest', label: 'Pinterest' },
]);

export const PLATFORM_PERF_IDS = excludeInstagramFromOptions([
  { value: 'instagram', label: 'Instagram' },
  { value: 'facebook', label: 'Facebook' },
  { value: 'twitter', label: 'Twitter' },
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'tiktok', label: 'TikTok' },
]).map((o) => o.value);

export const initialForm = {
  client_id: '',
  platforms: [],
  content: '',
  content_type: 'text',
  theme: '',
  scheduled_time: '',
  timezone: 'EST',
  title: '',
  video: null,
  image: null,
  hashtags: '',
  media_urls: '',
  // Phase 18.2-ADD-A: optional FB group share comment (blank → caption)
  group_share_text: '',
  group_share_texts: {},
};

/** Facebook group share "Say something…" max — matches Page post max. */
export const GROUP_SHARE_TEXT_MAX_LENGTH = 63206;
